// extracted by mini-css-extract-plugin
export default {"mobileSwiper":"mobile-slider-module--mobile-swiper--efeea","navigationDot":"mobile-slider-module--navigation-dot--270c7"};